import * as React from 'react';
import CodeBlock from 'Shared/icons/code-box-line.svg';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const CodeBlockButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleCodeBlock().run()}
         isActive={editor.isActive('codeBlock')}
         isDisabled={!editor.can().toggleCodeBlock()}
         icon={<CodeBlock />}
         /* Translators: "Code" as in monospaced font */
         title={_js('Insert code block')}
      ></TiptapButton>
   );
};
